module.exports = __webpack_public_path__ + "img/icon-checkedred.87414729.svg";